(function () {
  const AVAILABLE_MODULES = 3;
  const DEFAULT_CONFIG = "11111";

  function normalizeModuleNumber(value) {
    const moduleNum = parseInt(value, 10);

    if (Number.isNaN(moduleNum)) {
      return 1;
    }

    return Math.min(Math.max(moduleNum, 1), AVAILABLE_MODULES);
  }

  function parseConfigCode(code, defaultConfig, positionsCount) {
    const config = {};
    const normalizedCode = String(code || defaultConfig || DEFAULT_CONFIG).trim();
    const digits = normalizedCode.split("");

    for (let i = 1; i <= positionsCount; i += 1) {
      config[i] = normalizeModuleNumber(digits[i - 1]);
    }

    return config;
  }

  function createConfigCode(config, positionsCount) {
    let code = "";

    for (let i = 1; i <= positionsCount; i += 1) {
      code += normalizeModuleNumber(config[i]);
    }

    return code;
  }

  function addClickFeedback(element) {
    element.classList.remove("click-feedback");
    void element.offsetWidth;
    element.classList.add("click-feedback");

    window.setTimeout(() => {
      element.classList.remove("click-feedback");
    }, 300);
  }

  function initConfigurator(root) {
    if (root.dataset.blampaInitialized === "true") {
      return;
    }

    root.dataset.blampaInitialized = "true";

    const positionsCount = parseInt(root.getAttribute("data-positions-count"), 10) || 5;
    const defaultConfig = root.dataset.defaultConfig || DEFAULT_CONFIG;
    const moduleImageUrls = {
      1: root.getAttribute("data-module-1-url"),
      2: root.getAttribute("data-module-2-url"),
      3: root.getAttribute("data-module-3-url")
    };
    const configCodeElement = root.querySelector("[data-config-code]");
    const hiddenInput = root.querySelector("[data-configuration-input]");
    const resetButton = root.querySelector("[data-reset-config]");
    const moduleContainers = root.querySelectorAll(".lamp-module-container");
    let currentConfig = parseConfigCode(hiddenInput ? hiddenInput.value : defaultConfig, defaultConfig, positionsCount);

    function renderConfiguration() {
      const configCode = createConfigCode(currentConfig, positionsCount);

      moduleContainers.forEach((container) => {
        const position = parseInt(container.dataset.position, 10);
        const moduleNum = normalizeModuleNumber(currentConfig[position]);
        const img = container.querySelector(".lamp-module");

        if (img) {
          const nextUrl = moduleImageUrls[moduleNum] || moduleImageUrls[1] || img.src;

          img.removeAttribute("srcset");
          img.src = nextUrl;
          img.alt = `Moduł ${moduleNum} na pozycji ${position}`;
          img.dataset.currentModule = String(moduleNum);
        }
      });

      if (configCodeElement) {
        configCodeElement.textContent = configCode;
      }

      if (hiddenInput) {
        hiddenInput.value = configCode;
      }
    }

    function cycleModule(position) {
      if (position < 1 || position > positionsCount) {
        return;
      }

      const currentModule = currentConfig[position] || 1;
      currentConfig[position] = currentModule === AVAILABLE_MODULES ? 1 : currentModule + 1;
      renderConfiguration();
    }

    moduleContainers.forEach((container) => {
      const img = container.querySelector(".lamp-module");

      if (!img) {
        return;
      }

      container.addEventListener("click", () => {
        cycleModule(parseInt(container.dataset.position, 10));
        addClickFeedback(img);
      });
    });

    if (resetButton) {
      resetButton.addEventListener("click", () => {
        currentConfig = parseConfigCode(defaultConfig, defaultConfig, positionsCount);
        renderConfiguration();
      });
    }

    root.blampaConfigurator = {
      getConfigurationCode: () => createConfigCode(currentConfig, positionsCount),
      setConfigurationFromCode: (code) => {
        const normalizedCode = String(code || "").trim();

        if (normalizedCode.length === positionsCount) {
          currentConfig = parseConfigCode(normalizedCode, defaultConfig, positionsCount);
          renderConfiguration();
        }
      },
      resetConfiguration: () => {
        currentConfig = parseConfigCode(defaultConfig, defaultConfig, positionsCount);
        renderConfiguration();
      }
    };

    renderConfiguration();
  }

  function initAllConfigurators() {
    document.querySelectorAll("[data-blampa-configurator]").forEach(initConfigurator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllConfigurators);
  } else {
    initAllConfigurators();
  }

  document.addEventListener("shopify:section:load", initAllConfigurators);
})();
